const S_IN_M = 60;
const S_IN_H = 3600;
const M_IN_H = 60;
const S_IN_D = 86400;
const H_IN_D = 24;

/**
 * Format duration into h:mm:ss format. Must be a positive number.
 */
export default function formatTimeDurationHMS(seconds = 0): string {
  if (seconds < 0) seconds = 0;

  const dur = {
    ...(seconds >= S_IN_D ? { days: Math.floor(seconds / S_IN_D) } : {}),
    ...(seconds >= S_IN_H
      ? { hours: Math.floor((seconds / S_IN_H) % H_IN_D) }
      : {}),
    minutes: Math.floor((seconds / S_IN_M) % M_IN_H),
    seconds: Math.floor(seconds % S_IN_M),
  };

  const parts = [dur.days, dur.hours, dur.minutes, dur.seconds]
    .filter((n) => n !== undefined)
    .map((num, index, arr) => {
      // Remove leading zero for hours if there are no days
      if (index === 0 && arr.length === 3) {
        return String(num);
      }

      return String(num).padStart(2, '0');
    });

  return parts.join(':');
}
